webpackJsonp([235131596041995],{

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var trim = __webpack_require__(47)
	
	var comma = ','
	var space = ' '
	var empty = ''
	
	/* Parse comma-separated tokens to an array. */
	function parse(value) {
	  var values = []
	  var input = String(value || empty)
	  var index = input.indexOf(comma)
	  var lastIndex = 0
	  var end = false
	  var val
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length
	      end = true
	    }
	
	    val = trim(input.slice(lastIndex, index))
	
	    if (val || !end) {
	      values.push(val)
	    }
	
	    lastIndex = index + 1
	    index = input.indexOf(comma, lastIndex)
	  }
	
	  return values
	}
	
	/* Compile an array to comma-separated tokens.
	 * `options.padLeft` (default: `true`) pads a space left of each
	 * token, and `options.padRight` (default: `false`) pads a space
	 * to the right of each token. */
	function stringify(values, options) {
	  var settings = options || {}
	  var left = settings.padLeft === false ? empty : space
	  var right = settings.padRight ? space : empty
	
	  /* Ensure the last empty entry is seen. */
	  if (values[values.length - 1] === empty) {
	    values = values.concat(empty)
	  }
	
	  return trim(values.join(right + comma + left))
	}


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(152);
	var foreach = __webpack_require__(142);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	var toStr = Object.prototype.toString;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	        /* eslint-disable no-unused-vars, no-restricted-syntax */
	        for (var _ in obj) { return false; }
	        /* eslint-enable no-unused-vars, no-restricted-syntax */
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			Object.defineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = props.concat(Object.getOwnPropertySymbols(map));
		}
		foreach(props, function (name) {
			defineProperty(object, name, map[name], predicates[name]);
		});
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),

/***/ 142:
/***/ (function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(143);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(107);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(128);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(127);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(249);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(219);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(144);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 77:
/***/ (function(module, exports) {

	'use strict';
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	module.exports = function isNaN(value) {
		return value !== value;
	};


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(75);
	
	var implementation = __webpack_require__(77);
	var getPolyfill = __webpack_require__(78);
	var shim = __webpack_require__(150);
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	define(implementation, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = implementation;


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(77);
	
	module.exports = function getPolyfill() {
		if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
			return Number.isNaN;
		}
		return implementation;
	};


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(75);
	var getPolyfill = __webpack_require__(78);
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	module.exports = function shimNumberIsNaN() {
		var polyfill = getPolyfill();
		define(Number, { isNaN: polyfill }, { isNaN: function () { return Number.isNaN !== polyfill; } });
		return polyfill;
	};


/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	'use strict';
	var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;
	var REVERSE_REGEX = /-[a-z\u00E0-\u00F6\u00F8-\u00FE]/g;
	
	module.exports = exports = function kebabCase(str) {
		return str.replace(KEBAB_REGEX, function (match) {
			return '-' + match.toLowerCase();
		});
	};
	
	exports.reverse = function (str) {
		return str.replace(REVERSE_REGEX, function (match) {
			return match.slice(1).toUpperCase();
		});
	};


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(153);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),

/***/ 153:
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),

/***/ 154:
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = getPropertyInformation;
	
	/* Constants. */
	var USE_ATTRIBUTE = 0x1;
	var USE_PROPERTY = 0x2;
	var BOOLEAN_VALUE = 0x8;
	var NUMERIC_VALUE = 0x10;
	var POSITIVE_NUMERIC_VALUE = 0x20 | 0x10;
	var OVERLOADED_BOOLEAN_VALUE = 0x40;
	var SPACE_SEPARATED = 0x80;
	var COMMA_SEPARATED = 0x100;
	
	/* Map of properties. Names are camel-cased properties. */
	var propertyConfig = {
	  /* Standard Properties. */
	  abbr: null,
	  accept: COMMA_SEPARATED,
	  acceptCharset: SPACE_SEPARATED,
	  accessKey: SPACE_SEPARATED,
	  action: null,
	  allowFullScreen: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  allowTransparency: USE_ATTRIBUTE,
	  alt: null,
	  /* https://html.spec.whatwg.org/#attr-link-as */
	  as: null,
	  async: BOOLEAN_VALUE,
	  autoComplete: SPACE_SEPARATED,
	  autoFocus: BOOLEAN_VALUE,
	  autoPlay: BOOLEAN_VALUE,
	  capture: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  cellPadding: null,
	  cellSpacing: null,
	  challenge: USE_ATTRIBUTE,
	  charSet: USE_ATTRIBUTE,
	  checked: USE_PROPERTY | BOOLEAN_VALUE,
	  cite: null,
	  /* To set className on SVG elements, it's necessary to
	   * use .setAttribute; this works on HTML elements too
	   * in all browsers except IE8. */
	  className: USE_ATTRIBUTE | SPACE_SEPARATED,
	  cols: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  colSpan: null,
	  command: null,
	  content: null,
	  contentEditable: null,
	  contextMenu: USE_ATTRIBUTE,
	  controls: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://github.com/WICG/controls-list/blob/gh-pages/explainer.md */
	  controlsList: SPACE_SEPARATED,
	  coords: NUMERIC_VALUE | COMMA_SEPARATED,
	  crossOrigin: null,
	  /* For `<object />` acts as `src`. */
	  data: null,
	  dateTime: USE_ATTRIBUTE,
	  default: BOOLEAN_VALUE,
	  defer: BOOLEAN_VALUE,
	  dir: null,
	  dirName: null,
	  disabled: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  download: OVERLOADED_BOOLEAN_VALUE,
	  draggable: null,
	  dropzone: SPACE_SEPARATED,
	  encType: null,
	  form: USE_ATTRIBUTE,
	  formAction: USE_ATTRIBUTE,
	  formEncType: USE_ATTRIBUTE,
	  formMethod: USE_ATTRIBUTE,
	  formNoValidate: BOOLEAN_VALUE,
	  formTarget: USE_ATTRIBUTE,
	  frameBorder: USE_ATTRIBUTE,
	  headers: SPACE_SEPARATED,
	  height: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  hidden: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  high: NUMERIC_VALUE,
	  href: null,
	  hrefLang: null,
	  htmlFor: SPACE_SEPARATED,
	  httpEquiv: SPACE_SEPARATED,
	  id: USE_PROPERTY,
	  inputMode: USE_ATTRIBUTE,
	  /* Web Components */
	  is: USE_ATTRIBUTE,
	  isMap: BOOLEAN_VALUE,
	  keyParams: USE_ATTRIBUTE,
	  keyType: USE_ATTRIBUTE,
	  kind: null,
	  label: null,
	  lang: null,
	  list: USE_ATTRIBUTE,
	  loop: USE_PROPERTY | BOOLEAN_VALUE,
	  low: NUMERIC_VALUE,
	  manifest: USE_ATTRIBUTE,
	  marginHeight: NUMERIC_VALUE,
	  marginWidth: NUMERIC_VALUE,
	  max: null,
	  maxLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  media: USE_ATTRIBUTE,
	  mediaGroup: null,
	  menu: null,
	  method: null,
	  min: null,
	  minLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  multiple: USE_PROPERTY | BOOLEAN_VALUE,
	  muted: USE_PROPERTY | BOOLEAN_VALUE,
	  name: null,
	  nonce: null,
	  noValidate: BOOLEAN_VALUE,
	  open: BOOLEAN_VALUE,
	  optimum: NUMERIC_VALUE,
	  pattern: null,
	  ping: SPACE_SEPARATED,
	  placeholder: null,
	  /* https://html.spec.whatwg.org/#attr-video-playsinline */
	  playsInline: BOOLEAN_VALUE,
	  poster: null,
	  preload: null,
	  /* https://html.spec.whatwg.org/#dom-head-profile */
	  profile: null,
	  radioGroup: null,
	  readOnly: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://html.spec.whatwg.org/#attr-link-referrerpolicy */
	  referrerPolicy: null,
	  /* `rel` is `relList` in DOM */
	  rel: SPACE_SEPARATED | USE_ATTRIBUTE,
	  required: BOOLEAN_VALUE,
	  reversed: BOOLEAN_VALUE,
	  role: USE_ATTRIBUTE,
	  rows: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  rowSpan: POSITIVE_NUMERIC_VALUE,
	  sandbox: SPACE_SEPARATED,
	  scope: null,
	  scoped: BOOLEAN_VALUE,
	  scrolling: null,
	  seamless: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  selected: USE_PROPERTY | BOOLEAN_VALUE,
	  shape: null,
	  size: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  sizes: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* https://html.spec.whatwg.org/#attr-slot */
	  slot: null,
	  sortable: BOOLEAN_VALUE,
	  sorted: SPACE_SEPARATED,
	  span: POSITIVE_NUMERIC_VALUE,
	  spellCheck: null,
	  src: null,
	  srcDoc: USE_PROPERTY,
	  srcLang: null,
	  srcSet: USE_ATTRIBUTE | COMMA_SEPARATED,
	  start: NUMERIC_VALUE,
	  step: null,
	  style: null,
	  summary: null,
	  tabIndex: NUMERIC_VALUE,
	  target: null,
	  title: null,
	  translate: null,
	  type: null,
	  typeMustMatch: BOOLEAN_VALUE,
	  useMap: null,
	  value: USE_PROPERTY,
	  volume: POSITIVE_NUMERIC_VALUE,
	  width: USE_ATTRIBUTE | NUMERIC_VALUE,
	  wmode: USE_ATTRIBUTE,
	  wrap: null,
	
	  /* Non-standard Properties. */
	
	  /* `autoCapitalize` and `autoCorrect` are supported in
	   * Mobile Safari for keyboard hints. */
	  autoCapitalize: null,
	  autoCorrect: null,
	  /* `autoSave` allows WebKit/Blink to persist values of
	   * input fields on page reloads */
	  autoSave: null,
	  /* `itemProp`, `itemScope`, `itemType` are for Microdata
	   * support. See http://schema.org/docs/gs.html */
	  itemProp: USE_ATTRIBUTE | SPACE_SEPARATED,
	  itemScope: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  itemType: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `itemID` and `itemRef` are for Microdata support as well
	   * but only specified in the the WHATWG spec document.
	   * See https://html.spec.whatwg.org/multipage/
	   * microdata.html#microdata-dom-api */
	  itemID: USE_ATTRIBUTE,
	  itemRef: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `property` is supported for OpenGraph in meta tags. */
	  property: null,
	  /* `results` show looking glass icon and recent searches
	   * on input search fields in WebKit/Blink */
	  results: null,
	  /* IE-only attribute that specifies security
	   * restrictions on an iframe as an alternative to the
	   * sandbox attribute on IE < 10 */
	  security: USE_ATTRIBUTE,
	  /* IE-only attribute that controls focus behavior */
	  unselectable: USE_ATTRIBUTE,
	
	  /* Ancient. */
	  xmlLang: USE_ATTRIBUTE,
	  xmlBase: USE_ATTRIBUTE
	};
	
	/* Map of properties to attributes.
	 * Names are lower-case properties.
	 * Values are HTML attributes. */
	var propertyToAttributeMapping = {
	  xmlbase: 'xml:base',
	  xmllang: 'xml:lang',
	  classname: 'class',
	  htmlfor: 'for',
	  httpequiv: 'http-equiv',
	  acceptcharset: 'accept-charset'
	};
	
	/* Expand config. */
	var information = {};
	var property;
	var name;
	var config;
	
	getPropertyInformation.all = information;
	
	for (property in propertyConfig) {
	  name = lower(property);
	  name = propertyToAttributeMapping[name] || name;
	  config = propertyConfig[property];
	
	  information[name] = {
	    name: name,
	    propertyName: property,
	    mustUseAttribute: check(config, USE_ATTRIBUTE),
	    mustUseProperty: check(config, USE_PROPERTY),
	    boolean: check(config, BOOLEAN_VALUE),
	    overloadedBoolean: check(config, OVERLOADED_BOOLEAN_VALUE),
	    numeric: check(config, NUMERIC_VALUE),
	    positiveNumeric: check(config, POSITIVE_NUMERIC_VALUE),
	    commaSeparated: check(config, COMMA_SEPARATED),
	    spaceSeparated: check(config, SPACE_SEPARATED)
	  };
	}
	
	/* Get a config for a property. */
	function getPropertyInformation(propertyName) {
	  var insensitive = lower(propertyName);
	
	  return information[propertyToAttributeMapping[insensitive] || insensitive];
	}
	
	/* Check a mask. */
	function check(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	/* Lower-case a string. */
	function lower(value) {
	  return value.toLowerCase();
	}


/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var has = __webpack_require__(148);
	var toH = __webpack_require__(214);
	
	/* Expose `rehype-react`. */
	module.exports = rehype2react;
	
	/**
	 * Attach a react compiler.
	 *
	 * @param {Unified} processor - Instance.
	 * @param {Object?} [options]
	 * @param {Object?} [options.components]
	 *   - Components.
	 * @param {string?} [options.prefix]
	 *   - Key prefix.
	 * @param {Function?} [options.createElement]
	 *   - `h()`.
	 */
	function rehype2react(options) {
	  var settings = options || {};
	  var createElement = settings.createElement;
	  var components = settings.components || {};
	
	  this.Compiler = compiler;
	
	  /* Compile HAST to React. */
	  function compiler(node) {
	    if (node.type === 'root') {
	      if (node.children.length === 1 && node.children[0].type === 'element') {
	        node = node.children[0];
	      } else {
	        node = {
	          type: 'element',
	          tagName: 'div',
	          properties: {},
	          children: node.children
	        };
	      }
	    }
	
	    return toH(h, node, settings.prefix);
	  }
	
	  /* Wrap `createElement` to pass components in. */
	  function h(name, props, children) {
	    var component = has(components, name) ? components[name] : name;
	    return createElement(component, props, children);
	  }
	}


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(47);
	var paramCase = __webpack_require__(151);
	var information = __webpack_require__(154);
	var spaces = __webpack_require__(215);
	var commas = __webpack_require__(129);
	var nan = __webpack_require__(149);
	var is = __webpack_require__(216);
	
	module.exports = wrapper;
	
	function wrapper(h, node, prefix) {
	  var r;
	  var v;
	
	  if (typeof h !== 'function') {
	    throw new Error('h is not a function');
	  }
	
	  r = react(h);
	  v = vdom(h);
	
	  if (prefix === null || prefix === undefined) {
	    prefix = r === true || v === true ? 'h-' : false;
	  }
	
	  if (is('root', node)) {
	    if (node.children.length === 1 && is('element', node.children[0])) {
	      node = node.children[0];
	    } else {
	      node = {
	        type: 'element',
	        tagName: 'div',
	        properties: {},
	        children: node.children
	      };
	    }
	  } else if (!is('element', node)) {
	    throw new Error('Expected root or element, not `' + ((node && node.type) || node) + '`');
	  }
	
	  return toH(h, node, {
	    prefix: prefix,
	    key: 0,
	    react: r,
	    vdom: v,
	    hyperscript: hyperscript(h)
	  });
	}
	
	/* Transform a HAST node through a hyperscript interface
	 * to *anything*! */
	function toH(h, node, ctx) {
	  var selector = node.tagName;
	  var properties;
	  var attributes;
	  var children;
	  var property;
	  var elements;
	  var length;
	  var index;
	  var value;
	
	  properties = node.properties;
	  attributes = {};
	
	  for (property in properties) {
	    addAttribute(attributes, property, properties[property], ctx);
	  }
	
	  if (ctx.vdom === true) {
	    selector = selector.toUpperCase();
	  }
	
	  if (ctx.hyperscript === true && attributes.id) {
	    selector += '#' + attributes.id;
	    delete attributes.id;
	  }
	
	  if ((ctx.hyperscript === true || ctx.vdom === true) && attributes.className) {
	    selector += '.' + spaces.parse(attributes.className).join('.');
	    delete attributes.className;
	  }
	
	  if (typeof attributes.style === 'string') {
	    /* VDOM expects a `string` style in `attributes`
	     * See https://github.com/Matt-Esch/virtual-dom/blob/947ecf9/
	     * docs/vnode.md#propertiesstyle-vs-propertiesattributesstyle */
	    if (ctx.vdom === true) {
	      if (!attributes.attributes) {
	        attributes.attributes = {};
	      }
	
	      attributes.attributes.style = attributes.style;
	      delete attributes.style;
	    /* React only accepts `style` as object. */
	    } else if (ctx.react === true) {
	      attributes.style = parseStyle(attributes.style);
	    }
	  }
	
	  if (ctx.prefix) {
	    ctx.key++;
	    attributes.key = ctx.prefix + ctx.key;
	  }
	
	  elements = [];
	  children = node.children || [];
	  length = children.length;
	  index = -1;
	
	  while (++index < length) {
	    value = children[index];
	
	    if (is('element', value)) {
	      elements.push(toH(h, value, ctx));
	    } else if (is('text', value)) {
	      elements.push(value.value);
	    }
	  }
	
	  /* Ensure no React warnings are triggered for
	   * void elements having children passed in. */
	  return elements.length === 0 ? h(selector, attributes) : h(selector, attributes, elements);
	}
	
	/* Add `name` and its `value` to `props`. */
	function addAttribute(props, name, value, ctx) {
	  var info = information(name) || {};
	  var subprop;
	
	  /* Ignore nully, `false`, `NaN`, and falsey known
	   * booleans. */
	  if (
	    value === null ||
	    value === undefined ||
	    value === false ||
	    nan(value) ||
	    (info.boolean && !value)
	  ) {
	    return;
	  }
	
	  if (info.name) {
	    name = info.name;
	  } else if (ctx.react && !paramCasedReactProp(name)) {
	    name = camelCase(name);
	  } else {
	    name = paramCase(name);
	  }
	
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    /* Accept `array`.  Most props are space-separater. */
	    value = (info.commaSeparated ? commas : spaces).stringify(value);
	  }
	
	  /* Treat `true` and truthy known booleans. */
	  if (info.boolean && ctx.hyperscript === true) {
	    value = '';
	  }
	
	  if (info.name !== 'class' && (info.mustUseAttribute || !info.name)) {
	    if (ctx.vdom === true) {
	      subprop = 'attributes';
	    } else if (ctx.hyperscript === true) {
	      subprop = 'attrs';
	    }
	
	    if (subprop) {
	      if (props[subprop] === undefined) {
	        props[subprop] = {};
	      }
	
	      props[subprop][name] = value;
	
	      return;
	    }
	  }
	
	  props[info.propertyName || name] = value;
	}
	
	/* Check if `h` is `react.createElement`.  It doesn’t accept
	 * `class` as an attribute, it must be added through the
	 * `selector`. */
	function react(h) {
	  var node = h && h('div');
	  return Boolean(node && ('_owner' in node || '_store' in node) && node.key === null);
	}
	
	/* Check if `h` is `hyperscript`.  It doesn’t accept
	 * `class` as an attribute, it must be added through the
	 * `selector`. */
	function hyperscript(h) {
	  return Boolean(h && h.context && h.cleanup);
	}
	
	/**
	 * Check if `h` is `virtual-dom/h`.  It’s the only
	 * hyperscript “compatible” interface needing `attributes`. */
	function vdom(h) {
	  try {
	    return h('div').type === 'VirtualNode';
	  } catch (err) { /* Empty */ }
	
	  /* istanbul ignore next */
	  return false;
	}
	
	function parseStyle(value) {
	  var result = {};
	  var declarations = value.split(';');
	  var length = declarations.length;
	  var index = -1;
	  var declaration;
	  var prop;
	  var pos;
	
	  while (++index < length) {
	    declaration = declarations[index];
	    pos = declaration.indexOf(':');
	    if (pos !== -1) {
	      prop = camelCase(trim(declaration.slice(0, pos)));
	      result[prop] = trim(declaration.slice(pos + 1));
	    }
	  }
	
	  return result;
	}
	
	function paramCasedReactProp(name) {
	  var head = name.slice(0, 4);
	  return (head === 'data' || head === 'aria') && name.length > 4;
	}
	
	function camelCase(val) {
	  if (val.slice(0, 4) === '-ms-') {
	    val = 'ms-' + val.slice(4);
	  }
	
	  return val.replace(/-([a-z])/g, replace);
	}
	
	function replace($0, $1) {
	  return $1.toUpperCase();
	}


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var trim = __webpack_require__(47)
	
	exports.parse = parse
	exports.stringify = stringify
	
	var empty = ''
	var space = ' '
	var whiteSpace = /[ \t\n\r\f]+/g
	
	function parse(value) {
	  var input = trim(String(value || empty))
	  return input === empty ? [] : input.split(whiteSpace)
	}
	
	function stringify(values) {
	  return trim(values.join(space))
	}


/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),

/***/ 216:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable max-params */
	
	/* Expose. */
	module.exports = is;
	
	/* Assert if `test` passes for `node`.
	 * When a `parent` node is known the `index` of node */
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined;
	  var hasIndex = index !== null && index !== undefined;
	  var check = convert(test);
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node');
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node');
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false;
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index');
	  }
	
	  return Boolean(check.call(context, node, index, parent));
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test);
	  }
	
	  if (test === null || test === undefined) {
	    return ok;
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test);
	  }
	
	  if (typeof test === 'function') {
	    return test;
	  }
	
	  throw new Error('Expected function, string, or object as test');
	}
	
	function convertAll(tests) {
	  var results = [];
	  var length = tests.length;
	  var index = -1;
	
	  while (++index < length) {
	    results[index] = convert(tests[index]);
	  }
	
	  return results;
	}
	
	/* Utility assert each property in `test` is represented
	 * in `node`, and each values are strictly equal. */
	function matchesFactory(test) {
	  return matches;
	
	  function matches(node) {
	    var key;
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests);
	  var length = checks.length;
	
	  return matches;
	
	  function matches() {
	    var index = -1;
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	}
	
	/* Utility to convert a string into a function which checks
	 * a given node’s type for said string. */
	function typeFactory(test) {
	  return type;
	
	  function type(node) {
	    return Boolean(node && node.type === test);
	  }
	}
	
	/* Utility to return true. */
	function ok() {
	  return true;
	}


/***/ }),

/***/ 517:
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([bth[buf[i++]], bth[buf[i++]], 
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]]]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ }),

/***/ 518:
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(518);
	var bytesToUuid = __webpack_require__(517);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	    var intl = _ref.intl,
	        form = _ref.form,
	        onChange = _ref.onChange,
	        props = _objectWithoutProperties(_ref, ['intl', 'form', 'onChange']);
	
	    return _react2.default.createElement(
	        'div',
	        props,
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'text',
	                    name: 'name',
	                    placeholder: intl.formatMessage({
	                        id: 'conferenceProgramForm.name'
	                    }),
	                    value: form.name,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'text',
	                    name: 'company',
	                    placeholder: intl.formatMessage({
	                        id: 'conferenceProgramForm.company'
	                    }),
	                    value: form.company,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'email',
	                    name: 'email',
	                    placeholder: intl.formatMessage({
	                        id: 'conferenceProgramForm.email'
	                    }),
	                    value: form.email,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement('textarea', {
	                className: 'textarea',
	                name: 'subject',
	                rows: 3,
	                placeholder: intl.formatMessage({
	                    id: 'conferenceProgramForm.subject'
	                }),
	                value: form.subject,
	                onChange: onChange
	            })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: 'notification is-danger' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'contactForm.errorMessage' })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	var _classnames = __webpack_require__(50);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	    var onClick = _ref.onClick,
	        disabled = _ref.disabled,
	        isLoading = _ref.isLoading,
	        props = _objectWithoutProperties(_ref, ['onClick', 'disabled', 'isLoading']);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: 'field' }, props),
	        _react2.default.createElement(
	            'div',
	            { className: 'control' },
	            _react2.default.createElement(
	                'button',
	                {
	                    className: (0, _classnames2.default)('button', 'is-link', {
	                        'is-loading': isLoading
	                    }),
	                    onClick: onClick,
	                    disabled: disabled
	                },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'contactForm.submit' })
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: 'notification is-link' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'contactForm.successMessage' })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	var _Contacts = __webpack_require__(614);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	var _SubmitButton = __webpack_require__(616);
	
	var _SubmitButton2 = _interopRequireDefault(_SubmitButton);
	
	var _ErrorNotification = __webpack_require__(615);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	var _SuccessNotification = __webpack_require__(617);
	
	var _SuccessNotification2 = _interopRequireDefault(_SuccessNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function (_React$Component) {
	    _inherits(Form, _React$Component);
	
	    function Form() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Form);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            form: {
	                name: '',
	                company: '',
	                email: '',
	                subject: ''
	            },
	            isSubmitDisabled: false,
	            isLoading: false,
	            showForm: true,
	            showSuccess: false,
	            showError: false
	        }, _this.handleChange = function (event) {
	            var _extends2;
	
	            var _event$target = event.target,
	                name = _event$target.name,
	                value = _event$target.value;
	
	            _this.setState({ form: _extends({}, _this.state.form, (_extends2 = {}, _extends2[name] = value, _extends2)) });
	        }, _this.handleSubmit = function () {
	            _this.setState({
	                isSubmitDisabled: true,
	                isLoading: true,
	                showError: false
	            });
	
	            var error = false;
	
	            _this.sendForm().then(function (response) {
	                if (response.ok) {
	                    _this.setState({
	                        showSuccess: true,
	                        showForm: false,
	                        isLoading: false
	                    });
	                } else {
	                    error = true;
	                    _this.setState({
	                        showError: true,
	                        isSubmitDisabled: false,
	                        isLoading: false
	                    });
	                }
	                return response.text();
	            }).then(function (data) {
	                return error && console.log(data);
	            }).catch(function (err) {
	                _this.setState({
	                    showError: true,
	                    isSubmitDisabled: false,
	                    isLoading: false
	                });
	                console.log(err);
	            });
	        }, _this.sendForm = function () {
	            var form = _this.state.form;
	
	
	            return fetch('/.netlify/functions/conferenceProgram', {
	                method: 'post',
	                body: JSON.stringify({
	                    contacts: form
	                })
	            });
	        }, _this.isSubmitDisabled = function () {
	            var _this$state = _this.state,
	                form = _this$state.form,
	                isSubmitDisabled = _this$state.isSubmitDisabled;
	
	            return isSubmitDisabled || !!Object.keys(form).filter(function (key) {
	                return !form[key];
	            }).length;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Form.prototype.render = function render() {
	        var _state = this.state,
	            form = _state.form,
	            showSuccess = _state.showSuccess,
	            showError = _state.showError,
	            showForm = _state.showForm,
	            isLoading = _state.isLoading;
	        var intl = this.props.intl;
	
	
	        if (showSuccess) {
	            return _react2.default.createElement(_SuccessNotification2.default, null);
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: { marginTop: '2rem' } },
	            showForm && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h5',
	                    { className: 'title is-5' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'conferenceProgramForm.formTitle' })
	                ),
	                _react2.default.createElement(_Contacts2.default, {
	                    intl: intl,
	                    form: form,
	                    onChange: this.handleChange,
	                    style: { marginBottom: '1rem' }
	                }),
	                showError && _react2.default.createElement(_ErrorNotification2.default, {
	                    onClose: this.hideErrorMessage
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'is-flex' },
	                    _react2.default.createElement(_SubmitButton2.default, {
	                        onClick: this.handleSubmit,
	                        disabled: this.isSubmitDisabled(),
	                        isLoading: isLoading,
	                        style: {
	                            marginTop: '1rem',
	                            marginLeft: 'auto'
	                        }
	                    })
	                )
	            )
	        );
	    };
	
	    return Form;
	}(_react2.default.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(Form);
	module.exports = exports['default'];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _v = __webpack_require__(519);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _reactIntl = __webpack_require__(7);
	
	var _ApplicationItem = __webpack_require__(240);
	
	var _ApplicationItem2 = _interopRequireDefault(_ApplicationItem);
	
	var _Checkbox = __webpack_require__(124);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _ValueField = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var serviceFields = ['name', 'price', 'unit', 'value', 'amount'];
	
	var SERVICES = [{
	    name: 'shellScheme',
	    minValue: 6,
	    price: 470,
	    unit: 'sqrm',
	    primary: true
	}, {
	    name: 'spaceOnly',
	    minValue: 18,
	    price: 420,
	    unit: 'sqrm',
	    services: ['upperDeck'],
	    primary: true
	}, {
	    name: 'upperDeck',
	    minValue: 1,
	    maxValue: true,
	    price: 210,
	    unit: 'sqrm',
	    recalculate: true
	},
	// {
	//     name: 'staticDisplayChalet3',
	//     minValue: 1,
	//     price: 5000,
	//     unit: 'unit',
	//     services: ['wallBrandingChalet3'],
	//     primary: true,
	// },
	// {
	//     name: 'wallBrandingChalet3',
	//     minValue: 1,
	//     price: 500,
	//     unit: 'unit',
	// },
	{
	    name: 'staticDisplayChalet6',
	    minValue: 1,
	    price: 10000,
	    unit: 'unit',
	    services: ['wallBrandingChalet5'],
	    primary: true
	}, {
	    name: 'wallBrandingChalet5',
	    minValue: 1,
	    price: 1000,
	    unit: 'unit'
	}, {
	    name: 'staticDisplay',
	    primary: true,
	    price: 270,
	    unit: 'sqrm',
	    values: {
	        wingspan: {
	            name: 'wingspan',
	            unit: 'm',
	            minValue: 1
	        },
	        length: {
	            name: 'length',
	            unit: 'm',
	            minValue: 1
	        }
	    }
	}, {
	    name: 'brokerProject',
	    minValue: 1,
	    price: 2750,
	    unit: 'unit',
	    primary: true
	}, {
	    name: 'firstTimeExhibitor',
	    minValue: 1,
	    price: 1250,
	    unit: 'unit',
	    primary: true
	}];
	
	function normolize(obj) {
	    return serviceFields.reduce(function (o, key) {
	        var _extends2;
	
	        return _extends({}, o, (_extends2 = {}, _extends2[key] = obj[key], _extends2));
	    }, {});
	}
	
	var Application = function (_React$Component) {
	    _inherits(Application, _React$Component);
	
	    function Application() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Application);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            services: [{ id: (0, _v2.default)(), amount: 0 }],
	            catalogueAd: SERVICES.filter(function (service) {
	                return service.catalogueAd;
	            }).map(function (item) {
	                return _extends({}, item, { value: 0, amount: 0 });
	            }),
	            total: 0
	        }, _this.onChange = function (item, props) {
	            _this.setState({
	                services: _this.state.services.map(function (i) {
	                    return i.id === item.id ? _extends({}, item, props) : i;
	                })
	            }, _this.updateTotal);
	        }, _this.onRemove = function (item) {
	            _this.setState({
	                services: _this.state.services.filter(function (i) {
	                    return item.id !== i.id;
	                })
	            }, _this.updateTotal);
	        }, _this.showRemoveButton = function () {
	            return _this.state.services.length > 1;
	        }, _this.updateTotal = function () {
	            var _this$state = _this.state,
	                services = _this$state.services,
	                catalogueAd = _this$state.catalogueAd;
	
	            var total = services.reduce(function (sum, item) {
	                return sum + item.amount + (item.childServices ? item.childServices.reduce(function (sum, i) {
	                    return sum + i.amount;
	                }, 0) : 0);
	            }, 0) + catalogueAd.reduce(function (sum, item) {
	                return !!item.value ? sum + item.amount : sum;
	            }, 0);
	            _this.setState({
	                total: total
	            });
	            var normolizedServices = [].concat(services.filter(function (item) {
	                return !!item.name;
	            }).reduce(function (arr, item) {
	                var childServices = item.childServices,
	                    obj = _objectWithoutProperties(item, ['childServices']);
	
	                return [].concat(arr, [obj], childServices);
	            }, []), catalogueAd.filter(function (item) {
	                return !!item.value;
	            })).map(function (item) {
	                return normolize(item);
	            });
	            _this.props.onChange({
	                total: total,
	                services: normolizedServices
	            });
	        }, _this.showAddButton = function () {
	            return !_this.state.services.filter(function (item) {
	                return !item.name;
	            }).length;
	        }, _this.addItem = function () {
	            _this.setState({
	                services: [].concat(_this.state.services, [{ total: 0, id: (0, _v2.default)() }])
	            });
	        }, _this.handleCatalogueAdSelectChange = function (item) {
	            var catalogueAd = _this.state.catalogueAd;
	
	            var newValue = item.value ? 0 : 1;
	            _this.setState({
	                catalogueAd: catalogueAd.map(function (i) {
	                    return i.name === item.name ? _extends({}, i, {
	                        value: newValue,
	                        amount: item.price * newValue
	                    }) : i;
	                })
	            }, _this.updateTotal);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Application.prototype.render = function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            services = _state.services,
	            catalogueAd = _state.catalogueAd,
	            total = _state.total;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h6',
	                { className: 'title is-6' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'exhibitApplication.allocationTitle' })
	            ),
	            services.map(function (item) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: item.id },
	                    _react2.default.createElement(_ApplicationItem2.default, {
	                        item: item,
	                        services: SERVICES,
	                        onChange: _this2.onChange,
	                        showRemoveButton: _this2.showRemoveButton(),
	                        onRemove: _this2.onRemove
	                    }),
	                    _react2.default.createElement('hr', null)
	                );
	            }),
	            this.showAddButton() && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'is-flex' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'button is-primary',
	                            onClick: this.addItem,
	                            style: { marginLeft: 'auto' }
	                        },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'exhibitApplication.addButton' })
	                    )
	                ),
	                _react2.default.createElement('hr', null)
	            ),
	            _react2.default.createElement(
	                'h3',
	                { style: { display: 'flex', justifyContent: 'flex-end' } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'exhibitApplication.total' }),
	                ':',
	                ' ',
	                _react2.default.createElement(
	                    'span',
	                    { style: { paddingLeft: '1rem' } },
	                    '\u20AC',
	                    total
	                )
	            )
	        );
	    };
	
	    return Application;
	}(_react2.default.Component);
	
	exports.default = Application;
	module.exports = exports['default'];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    margin: 1rem 0 !important;\n'], ['\n    margin: 1rem 0 !important;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n'], ['\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ServiceDropdown = __webpack_require__(243);
	
	var _ServiceDropdown2 = _interopRequireDefault(_ServiceDropdown);
	
	var _ValueField = __webpack_require__(125);
	
	var _ValueField2 = _interopRequireDefault(_ValueField);
	
	var _Checkbox = __webpack_require__(124);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ServiceDescription = _styledComponents2.default.div(_templateObject);
	
	var SelectionRow = _styledComponents2.default.div(_templateObject2);
	
	var ApplicationItem = function (_React$Component) {
	    _inherits(ApplicationItem, _React$Component);
	
	    function ApplicationItem() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ApplicationItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            serviceDropdownOpened: false,
	            selectedService: null,
	            value: 0,
	            amount: 0,
	            childServices: [],
	            values: {}
	        }, _this.initChildServices = function (service) {
	            if (!service.services) {
	                return [];
	            }
	            var childServices = _this.props.services.filter(function (item) {
	                return service.services.filter(function (i) {
	                    return i === item.name;
	                }).length;
	            }).map(function (item) {
	                return _extends({}, item, {
	                    value: item.minValue,
	                    amount: item.minValue * item.price,
	                    selected: false
	                });
	            });
	            return childServices;
	        }, _this.renderChildService = function (childServiceName) {
	            var childService = _this.state.childServices.find(function (item) {
	                return item.name = childServiceName;
	            });
	            var selected = childService.selected,
	                value = childService.value,
	                amount = childService.amount,
	                unit = childService.unit,
	                price = childService.price;
	
	
	            return _react2.default.createElement(
	                'div',
	                { key: childServiceName, style: { marginTop: '1rem' } },
	                _react2.default.createElement(_Checkbox2.default, {
	                    selected: selected,
	                    onChange: function onChange() {
	                        return _this.handleChildServiceSelectChange(childService);
	                    },
	                    messageId: 'exhibitApplication.services.' + childServiceName + '.title',
	                    style: { marginBottom: selected ? '0.5rem' : 0 }
	                }),
	                selected && _react2.default.createElement(_ValueField2.default, {
	                    value: value,
	                    onChange: function onChange(event) {
	                        return _this.handleChildServiceValueChange(event, childService);
	                    },
	                    unit: unit,
	                    price: price,
	                    amount: amount
	                })
	            );
	        }, _this.handleServiceDropdownClick = function () {
	            _this.setState({
	                serviceDropdownOpened: !_this.state.serviceDropdownOpened
	            });
	        }, _this.handleSelectService = function (event) {
	            var selectedService = _this.props.services.find(function (item) {
	                return item.name === event.currentTarget.dataset.name;
	            });
	            if (_this.state.selectedService && selectedService.name === _this.state.selectedService.name) {
	                _this.setState({
	                    serviceDropdownOpened: false
	                });
	                return;
	            }
	            var values = selectedService.values && Object.keys(selectedService.values).reduce(function (prev, cur) {
	                var _extends2;
	
	                return _extends({}, prev, (_extends2 = {}, _extends2[cur] = selectedService.values[cur].minValue, _extends2));
	            }, {});
	            _this.setState({
	                selectedService: selectedService,
	                value: selectedService.minValue,
	                values: values,
	                amount: values ? _this.calculateAmount(selectedService.price, values) : selectedService.price * selectedService.minValue,
	                serviceDropdownOpened: false,
	                childServices: _this.initChildServices(selectedService)
	            }, _this.onChange);
	        }, _this.handleValueChange = function (event) {
	            var value = Number(event.currentTarget.value);
	            var selectedService = _this.state.selectedService;
	
	            var newValue = value < selectedService.minValue ? selectedService.minValue : value;
	            _this.setState({
	                value: newValue,
	                amount: selectedService.price * newValue,
	                childServices: _this.recalculateChildServices(newValue)
	            }, _this.onChange);
	        }, _this.calculateAmount = function (price, values) {
	            return _this.valueFromValues(values) / 9 * price;
	        }, _this.valueFromValues = function (values) {
	            return Object.keys(values).reduce(function (prev, cur) {
	                return prev * values[cur];
	            }, 1);
	        }, _this.handleValuesChange = function (name) {
	            return function (event) {
	                var _extends3;
	
	                var newValue = Number(event.currentTarget.value);
	                var selectedService = _this.state.selectedService;
	
	
	                var values = _extends({}, _this.state.values, (_extends3 = {}, _extends3[name] = newValue, _extends3));
	                var value = _this.valueFromValues(values);
	                var amount = _this.calculateAmount(selectedService.price, values);
	                _this.setState({
	                    values: values,
	                    value: value,
	                    amount: amount
	                }, _this.onChange);
	            };
	        }, _this.handleChildServiceSelectChange = function (service) {
	            var childServices = _this.state.childServices;
	
	            _this.setState({
	                childServices: childServices.map(function (item) {
	                    return item.name === service.name ? _extends({}, item, { selected: !service.selected }) : item;
	                })
	            }, _this.onChange);
	        }, _this.handleChildServiceValueChange = function (event, service) {
	            var _this$state = _this.state,
	                childServices = _this$state.childServices,
	                applicationValue = _this$state.value;
	
	            var value = Number(event.currentTarget.value);
	            var newValue = _this.getChildServiceValue(value, applicationValue, service);
	            _this.setState({
	                childServices: childServices.map(function (item) {
	                    return item.name === service.name ? _extends({}, item, {
	                        value: newValue,
	                        amount: newValue * service.price
	                    }) : item;
	                })
	            }, _this.onChange);
	        }, _this.getChildServiceValue = function (value, applicationValue, service) {
	            return service.minValue && value < service.minValue ? service.minValue : service.maxValue && value > applicationValue ? applicationValue : value;
	        }, _this.recalculateChildServices = function (applicationValue) {
	            return _this.state.childServices.map(function (service) {
	                if (!service.selected && !service.recalculate) {
	                    return service;
	                }
	                var newValue = _this.getChildServiceValue(service.value, applicationValue, service);
	                return _extends({}, service, {
	                    value: newValue,
	                    amount: newValue * service.price
	                });
	            });
	        }, _this.onChange = function () {
	            var _this$state2 = _this.state,
	                selectedService = _this$state2.selectedService,
	                childServices = _this$state2.childServices,
	                value = _this$state2.value,
	                amount = _this$state2.amount;
	
	            _this.props.onChange(_this.props.item, {
	                name: selectedService.name,
	                price: selectedService.price,
	                unit: selectedService.unit,
	                value: value,
	                amount: amount,
	                childServices: childServices.filter(function (item) {
	                    return item.selected;
	                })
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    ApplicationItem.prototype.render = function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            selectedService = _state.selectedService,
	            value = _state.value,
	            values = _state.values,
	            amount = _state.amount,
	            serviceDropdownOpened = _state.serviceDropdownOpened;
	        var _props = this.props,
	            services = _props.services,
	            showRemoveButton = _props.showRemoveButton,
	            onRemove = _props.onRemove,
	            item = _props.item,
	            intl = _props.intl;
	
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                SelectionRow,
	                null,
	                _react2.default.createElement(_ServiceDropdown2.default, {
	                    items: services.filter(function (item) {
	                        return item.primary;
	                    }),
	                    opened: serviceDropdownOpened,
	                    selectedItem: selectedService,
	                    onClick: this.handleServiceDropdownClick,
	                    onSelect: this.handleSelectService
	                }),
	                showRemoveButton && _react2.default.createElement('button', {
	                    className: 'delete',
	                    onClick: function onClick() {
	                        return onRemove(item);
	                    }
	                })
	            ),
	            selectedService && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    ServiceDescription,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'notification' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'exhibitApplication.services.' + selectedService.name + '.description',
	                            tagName: 'p'
	                        })
	                    )
	                ),
	                selectedService.values ? _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex' } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { flex: 1 } },
	                        Object.keys(selectedService.values).map(function (key) {
	                            return _react2.default.createElement(_ValueField2.default, {
	                                key: key,
	                                title: intl.formatMessage({
	                                    id: 'exhibitApplication.services.' + selectedService.name + '.' + key
	                                }),
	                                value: values[key],
	                                unit: selectedService.values[key].unit,
	                                onChange: _this2.handleValuesChange(key)
	                            });
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _ValueField.Value,
	                        { style: { alignSelf: 'center' } },
	                        '\u20AC',
	                        amount
	                    )
	                ) : _react2.default.createElement(_ValueField2.default, {
	                    value: value,
	                    onChange: this.handleValueChange,
	                    unit: selectedService.unit,
	                    price: selectedService.price,
	                    amount: amount
	                }),
	                selectedService.services && selectedService.services.map(this.renderChildService)
	            )
	        );
	    };
	
	    return ApplicationItem;
	}(_react2.default.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ApplicationItem);
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	    var selected = _ref.selected,
	        onChange = _ref.onChange,
	        messageId = _ref.messageId,
	        props = _objectWithoutProperties(_ref, ['selected', 'onChange', 'messageId']);
	
	    return _react2.default.createElement(
	        'label',
	        _extends({ className: 'checkbox' }, props),
	        _react2.default.createElement('input', { type: 'checkbox', value: selected, onChange: onChange }),
	        _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: messageId },
	            function (message) {
	                return _react2.default.createElement(
	                    'span',
	                    {
	                        style: {
	                            marginLeft: '1rem'
	                        }
	                    },
	                    message
	                );
	            }
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	    var intl = _ref.intl,
	        form = _ref.form,
	        onChange = _ref.onChange,
	        props = _objectWithoutProperties(_ref, ['intl', 'form', 'onChange']);
	
	    return _react2.default.createElement(
	        'div',
	        props,
	        _react2.default.createElement(
	            'h6',
	            { className: 'title is-6' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'exhibitApplication.contactsTitle' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'text',
	                    name: 'name',
	                    placeholder: intl.formatMessage({
	                        id: 'contactForm.name'
	                    }),
	                    value: form.name,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'text',
	                    name: 'contactPerson',
	                    placeholder: intl.formatMessage({
	                        id: 'contactForm.contactPerson'
	                    }),
	                    value: form.contactPerson,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'text',
	                    name: 'address',
	                    placeholder: intl.formatMessage({
	                        id: 'contactForm.address'
	                    }),
	                    value: form.address,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'tel',
	                    name: 'tel',
	                    placeholder: intl.formatMessage({
	                        id: 'contactForm.tel'
	                    }),
	                    value: form.tel,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'email',
	                    name: 'email',
	                    placeholder: intl.formatMessage({
	                        id: 'contactForm.email'
	                    }),
	                    value: form.email,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'text',
	                    name: 'website',
	                    placeholder: intl.formatMessage({
	                        id: 'contactForm.website'
	                    }),
	                    value: form.website,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'text',
	                    name: 'boothNumber',
	                    placeholder: intl.formatMessage({
	                        id: 'contactForm.boothNumber'
	                    }),
	                    value: form.boothNumber,
	                    onChange: onChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', {
	                    className: 'input',
	                    type: 'text',
	                    name: 'promo',
	                    placeholder: intl.formatMessage({
	                        id: 'contactForm.promo'
	                    }),
	                    value: form.promo,
	                    onChange: onChange
	                })
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: 'notification is-danger' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'contactForm.errorMessage' })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(50);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var items = _ref.items,
	        opened = _ref.opened,
	        selectedItem = _ref.selectedItem,
	        onSelect = _ref.onSelect,
	        onClick = _ref.onClick;
	
	    var dropdownClasses = (0, _classnames2.default)('dropdown', {
	        'is-active': opened
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: dropdownClasses },
	        _react2.default.createElement(
	            'div',
	            { className: 'dropdown-trigger', onClick: onClick },
	            _react2.default.createElement(
	                'button',
	                { className: 'button has-text-weight-bold' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: selectedItem ? 'exhibitApplication.services.' + selectedItem.name + '.title' : 'exhibitApplication.applicationTypeButton',
	                    tagName: 'span'
	                }),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'icon is-small' },
	                    _react2.default.createElement('i', { className: 'fas fa-angle-down' })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'dropdown-menu' },
	            _react2.default.createElement(
	                'div',
	                { className: 'dropdown-content' },
	                items.map(function (item) {
	                    return _react2.default.createElement(
	                        'a',
	                        {
	                            key: item.name,
	                            onClick: onSelect,
	                            'data-name': item.name,
	                            className: (0, _classnames2.default)('dropdown-item', {
	                                'is-active': selectedItem && item.name === selectedItem.name
	                            })
	                        },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'exhibitApplication.services.' + item.name + '.title'
	                        })
	                    );
	                })
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	var _classnames = __webpack_require__(50);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	    var onClick = _ref.onClick,
	        disabled = _ref.disabled,
	        isLoading = _ref.isLoading,
	        props = _objectWithoutProperties(_ref, ['onClick', 'disabled', 'isLoading']);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: 'field' }, props),
	        _react2.default.createElement(
	            'div',
	            { className: 'control' },
	            _react2.default.createElement(
	                'button',
	                {
	                    className: (0, _classnames2.default)('button', 'is-link', {
	                        'is-loading': isLoading
	                    }),
	                    onClick: onClick,
	                    disabled: disabled
	                },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'contactForm.submit' })
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: 'notification is-link' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'contactForm.successMessage' })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValueField = exports.Value = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    margin-left: 1rem;\n    font-size: 120%;\n    line-height: 120%;\n    color: rgb(0, 48, 86);\n'], ['\n    margin-left: 1rem;\n    font-size: 120%;\n    line-height: 120%;\n    color: rgb(0, 48, 86);\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Value = exports.Value = _styledComponents2.default.span(_templateObject);
	
	var ValueField = function ValueField(_ref) {
	    var intl = _ref.intl,
	        value = _ref.value,
	        onChange = _ref.onChange,
	        unit = _ref.unit,
	        price = _ref.price,
	        amount = _ref.amount,
	        title = _ref.title,
	        props = _objectWithoutProperties(_ref, ['intl', 'value', 'onChange', 'unit', 'price', 'amount', 'title']);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'field is-horizontal' },
	        title && _react2.default.createElement(
	            'div',
	            { className: 'field-label is-normal', style: { flexGrow: 3 } },
	            _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                title
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field-body' },
	            _react2.default.createElement(
	                'div',
	                _extends({
	                    className: 'field has-addons'
	                }, props, {
	                    style: { marginBottom: '-1rem' }
	                }),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'control' },
	                    _react2.default.createElement('input', {
	                        className: 'input',
	                        type: 'number',
	                        placeholder: intl.formatMessage({
	                            id: 'exhibitApplication.valuePlaceholder'
	                        }),
	                        value: value,
	                        min: 0,
	                        onChange: onChange
	                    })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'control' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'button is-static' },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'exhibitApplication.units.' + unit
	                        })
	                    )
	                ),
	                price && _react2.default.createElement(
	                    'p',
	                    { className: 'control' },
	                    _react2.default.createElement(
	                        Value,
	                        { className: 'input is-static' },
	                        '\xD7 \u20AC',
	                        price
	                    )
	                ),
	                amount && _react2.default.createElement(
	                    'p',
	                    { className: 'control', style: { marginLeft: 'auto' } },
	                    _react2.default.createElement(
	                        Value,
	                        { className: 'input is-static' },
	                        '\u20AC',
	                        amount
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.ValueField = ValueField;
	exports.default = (0, _reactIntl.injectIntl)(ValueField);

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(7);
	
	var _Contacts = __webpack_require__(241);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	var _Application = __webpack_require__(239);
	
	var _Application2 = _interopRequireDefault(_Application);
	
	var _SubmitButton = __webpack_require__(244);
	
	var _SubmitButton2 = _interopRequireDefault(_SubmitButton);
	
	var _ErrorNotification = __webpack_require__(242);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	var _SuccessNotification = __webpack_require__(245);
	
	var _SuccessNotification2 = _interopRequireDefault(_SuccessNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactForm = function (_React$Component) {
	    _inherits(ContactForm, _React$Component);
	
	    function ContactForm() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ContactForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            form: {
	                name: '',
	                contactPerson: '',
	                tel: '',
	                email: '',
	                format: 'stand',
	                address: '',
	                website: '',
	                promo: '',
	                boothNumber: ''
	            },
	            isSubmitDisabled: false,
	            isLoading: false,
	            showForm: true,
	            showSuccess: false,
	            showError: false,
	            application: null
	        }, _this.handleChange = function (event) {
	            var _extends2;
	
	            var _event$target = event.target,
	                name = _event$target.name,
	                value = _event$target.value;
	
	            _this.setState({ form: _extends({}, _this.state.form, (_extends2 = {}, _extends2[name] = value, _extends2)) });
	        }, _this.handleSubmit = function () {
	            _this.setState({
	                isSubmitDisabled: true,
	                isLoading: true,
	                showError: false
	            });
	
	            var error = false;
	
	            _this.sendApplication().then(function (response) {
	                if (response.ok) {
	                    _this.setState({
	                        showSuccess: true,
	                        showForm: false,
	                        isLoading: false
	                    });
	                } else {
	                    error = true;
	                    _this.setState({
	                        showError: true,
	                        isSubmitDisabled: false,
	                        isLoading: false
	                    });
	                }
	                return response.text();
	            }).then(function (data) {
	                return error && console.log(data);
	            }).catch(function (err) {
	                _this.setState({
	                    showError: true,
	                    isSubmitDisabled: false,
	                    isLoading: false
	                });
	                console.log(err);
	            });
	        }, _this.sendApplication = function () {
	            var _this$state = _this.state,
	                form = _this$state.form,
	                application = _this$state.application;
	
	            return fetch('/.netlify/functions/exhibitApplication', {
	                method: 'post',
	                body: JSON.stringify({
	                    contacts: form,
	                    application: application
	                })
	            });
	        }, _this.isSubmitDisabled = function () {
	            var _this$state2 = _this.state,
	                form = _this$state2.form,
	                application = _this$state2.application,
	                isSubmitDisabled = _this$state2.isSubmitDisabled;
	
	            return isSubmitDisabled ||
	            // !!Object.keys(form).filter((key) => !form[key]).length ||
	            !application || !application.services.length;
	        }, _this.handleApplicationChange = function (application) {
	            console.log(application);
	            _this.setState({
	                application: application
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    ContactForm.prototype.render = function render() {
	        var _state = this.state,
	            form = _state.form,
	            showSuccess = _state.showSuccess,
	            showError = _state.showError,
	            showForm = _state.showForm,
	            isLoading = _state.isLoading;
	        var intl = this.props.intl;
	
	
	        if (showSuccess) {
	            return _react2.default.createElement(_SuccessNotification2.default, null);
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: { marginTop: '2rem' } },
	            showForm && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h5',
	                    { className: 'title is-5' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'exhibitApplication.formTitle' })
	                ),
	                _react2.default.createElement(_Contacts2.default, {
	                    intl: intl,
	                    form: form,
	                    onChange: this.handleChange,
	                    style: { marginBottom: '2rem' }
	                }),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(_Application2.default, { onChange: this.handleApplicationChange }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'notification' },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'exhibitApplication.comment',
	                        tagName: 'p'
	                    })
	                ),
	                showError && _react2.default.createElement(_ErrorNotification2.default, {
	                    onClose: this.hideErrorMessage
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'is-flex' },
	                    _react2.default.createElement(_SubmitButton2.default, {
	                        onClick: this.handleSubmit,
	                        disabled: this.isSubmitDisabled(),
	                        isLoading: isLoading,
	                        style: {
	                            marginTop: '2rem',
	                            marginLeft: 'auto'
	                        }
	                    })
	                )
	            )
	        );
	    };
	
	    return ContactForm;
	}(_react2.default.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ContactForm);
	module.exports = exports['default'];

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    vertical-align: middle !important;\n'], ['\n    vertical-align: middle !important;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    text-align: center;\n    vertical-align: middle !important;\n    // img {\n    //     max-width: 200px;\n    //     max-height: 100px;\n    //     padding: 10px;\n    // }\n'], ['\n    text-align: center;\n    vertical-align: middle !important;\n    // img {\n    //     max-width: 200px;\n    //     max-height: 100px;\n    //     padding: 10px;\n    // }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    width: 200px;\n    max-height: 100px;\n    margin: 5px;\n    @media (max-width: ', ') {\n        width: 100px;\n    }\n'], ['\n    width: 200px;\n    max-height: 100px;\n    margin: 5px;\n    @media (max-width: ', ') {\n        width: 100px;\n    }\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(292);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _constants = __webpack_require__(30);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var NameCell = _styledComponents2.default.td(_templateObject);
	
	var StandCell = NameCell;
	
	var LogoCell = _styledComponents2.default.td(_templateObject2);
	
	var Img = (0, _styledComponents2.default)(_gatsbyImage2.default)(_templateObject3, _constants.breakpoints.mobile);
	
	exports.default = (0, _reactIntl.injectIntl)(function (_ref) {
	    var _ref2;
	
	    var exhibitors = _ref.exhibitors,
	        logos = _ref.logos,
	        intl = _ref.intl,
	        filter = _ref.filter,
	        filterOpened = _ref.filterOpened,
	        toggleFilter = _ref.toggleFilter,
	        setExhibitorsFilter = _ref.setExhibitorsFilter;
	
	    var categories = (_ref2 = []).concat.apply(_ref2, exhibitors.map(function (_ref3) {
	        var categories = _ref3.node.categories;
	        return categories ? categories.map(function (_ref4) {
	            var nameRu = _ref4.nameRu,
	                nameEn = _ref4.nameEn,
	                id = _ref4.id;
	            return {
	                id: id,
	                name: intl.locale === 'ru' ? nameRu : nameEn
	            };
	        }) : [];
	    }));
	
	    var uniqCategoriesId = [];
	    var uniqCategories = [];
	
	    categories.forEach(function (value, index) {
	        if (!uniqCategoriesId.includes(value.id)) {
	            uniqCategoriesId.push(value.id);
	            uniqCategories.push(value);
	        }
	    });
	
	    var defaultFilterLabel = intl.formatMessage({
	        id: 'pages.exhibitors.filterDefault'
	    });
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'dropdown ' + (filterOpened ? 'is-active' : ''),
	                onClick: toggleFilter
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'dropdown-trigger' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: 'button',
	                        'aria-haspopup': 'true',
	                        'aria-controls': 'dropdown-menu'
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        filter ? filter.name : defaultFilterLabel
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'icon is-small' },
	                        _react2.default.createElement('i', {
	                            className: 'fas fa-angle-down',
	                            'aria-hidden': 'true'
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    className: 'dropdown-menu',
	                    id: 'dropdown-menu',
	                    role: 'menu'
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'dropdown-content' },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            className: 'dropdown-item ' + (!filter ? 'is-active' : ''),
	                            style: { textDecoration: 'none' },
	                            onClick: function onClick() {
	                                return setExhibitorsFilter(null);
	                            }
	                        },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pages.exhibitors.filterAll' })
	                    ),
	                    uniqCategories.map(function (_ref5) {
	                        var id = _ref5.id,
	                            name = _ref5.name;
	                        return _react2.default.createElement(
	                            'a',
	                            {
	                                key: id,
	                                className: 'dropdown-item ' + (filter && filter.name === name ? 'is-active' : ''),
	                                style: { textDecoration: 'none' },
	                                onClick: function onClick() {
	                                    return setExhibitorsFilter({ id: id, name: name });
	                                }
	                            },
	                            name
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table' },
	            _react2.default.createElement(
	                'tbody',
	                null,
	                exhibitors.filter(function (_ref6) {
	                    var categories = _ref6.node.categories;
	                    return !filter || categories.find(function (_ref7) {
	                        var id = _ref7.id;
	                        return id === filter.id;
	                    });
	                }).sort(function (a, b) {
	                    return a.node.name > b.node.name ? 1 : -1;
	                }).map(function (_ref8) {
	                    var node = _ref8.node;
	
	                    var sizes = getLogoSizes(node.code, logos);
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: node.id },
	                        _react2.default.createElement(
	                            NameCell,
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: extractWebsite(node.website),
	                                    target: '__blank'
	                                },
	                                node.name
	                            )
	                        ),
	                        _react2.default.createElement(
	                            NameCell,
	                            null,
	                            node.categories && node.categories.map(function (item) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    { key: item.id },
	                                    intl.locale === 'ru' ? item.nameRu : item.nameEn
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            LogoCell,
	                            null,
	                            sizes && _react2.default.createElement(Img, {
	                                sizes: sizes,
	                                imgStyle: {
	                                    objectFit: 'contain'
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            StandCell,
	                            null,
	                            node.stand
	                        )
	                    );
	                })
	            )
	        )
	    );
	});
	
	
	var getLogoSizes = function getLogoSizes(code, logos) {
	    var logo = logos.find(function (_ref9) {
	        var node = _ref9.node;
	        return node.name === code;
	    });
	    return logo && logo.node.childImageSharp.sizes;
	};
	
	var extractWebsite = function extractWebsite(str) {
	    if (!str) {
	        return 'javascript:;';
	    }
	    var url = str && str.split(/[\s,;]/)[0] || '';
	    return url.substr(0, 4) === 'http' ? url : 'http://' + url;
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhLS0gQ3JlYXRlZCB3aXRoIElua3NjYXBlIChodHRwOi8vd3d3Lmlua3NjYXBlLm9yZy8pIC0tPgoKPHN2ZwogICB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iCiAgIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiCiAgIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICB4bWxuczpzb2RpcG9kaT0iaHR0cDovL3NvZGlwb2RpLnNvdXJjZWZvcmdlLm5ldC9EVEQvc29kaXBvZGktMC5kdGQiCiAgIHhtbG5zOmlua3NjYXBlPSJodHRwOi8vd3d3Lmlua3NjYXBlLm9yZy9uYW1lc3BhY2VzL2lua3NjYXBlIgogICB3aWR0aD0iMTIuMzg1MDE0bW0iCiAgIGhlaWdodD0iMTIuMzg1MDRtbSIKICAgdmlld0JveD0iMCAwIDEyLjM4NTAxNCAxMi4zODUwNCIKICAgdmVyc2lvbj0iMS4xIgogICBpZD0ic3ZnNTMxMiIKICAgaW5rc2NhcGU6dmVyc2lvbj0iMC45Mi4yIDVjM2U4MGQsIDIwMTctMDgtMDYiCiAgIHNvZGlwb2RpOmRvY25hbWU9ItC60LDQu9C10L3QtNCw0YDRjC5zdmciPgogIDxkZWZzCiAgICAgaWQ9ImRlZnM1MzA2IiAvPgogIDxzb2RpcG9kaTpuYW1lZHZpZXcKICAgICBpZD0iYmFzZSIKICAgICBwYWdlY29sb3I9IiNmZmZmZmYiCiAgICAgYm9yZGVyY29sb3I9IiM2NjY2NjYiCiAgICAgYm9yZGVyb3BhY2l0eT0iMS4wIgogICAgIGlua3NjYXBlOnBhZ2VvcGFjaXR5PSIwLjAiCiAgICAgaW5rc2NhcGU6cGFnZXNoYWRvdz0iMiIKICAgICBpbmtzY2FwZTp6b29tPSIzLjk1OTc5OCIKICAgICBpbmtzY2FwZTpjeD0iMzguNzY2MTUyIgogICAgIGlua3NjYXBlOmN5PSItMjAuODExMjAxIgogICAgIGlua3NjYXBlOmRvY3VtZW50LXVuaXRzPSJtbSIKICAgICBpbmtzY2FwZTpjdXJyZW50LWxheWVyPSJsYXllcjEiCiAgICAgc2hvd2dyaWQ9ImZhbHNlIgogICAgIGZpdC1tYXJnaW4tdG9wPSIwIgogICAgIGZpdC1tYXJnaW4tbGVmdD0iMCIKICAgICBmaXQtbWFyZ2luLXJpZ2h0PSIwIgogICAgIGZpdC1tYXJnaW4tYm90dG9tPSIwIgogICAgIGlua3NjYXBlOndpbmRvdy13aWR0aD0iMTkyMCIKICAgICBpbmtzY2FwZTp3aW5kb3ctaGVpZ2h0PSI5NjUiCiAgICAgaW5rc2NhcGU6d2luZG93LXg9IjMiCiAgICAgaW5rc2NhcGU6d2luZG93LXk9IjIxOCIKICAgICBpbmtzY2FwZTp3aW5kb3ctbWF4aW1pemVkPSIwIiAvPgogIDxtZXRhZGF0YQogICAgIGlkPSJtZXRhZGF0YTUzMDkiPgogICAgPHJkZjpSREY+CiAgICAgIDxjYzpXb3JrCiAgICAgICAgIHJkZjphYm91dD0iIj4KICAgICAgICA8ZGM6Zm9ybWF0PmltYWdlL3N2Zyt4bWw8L2RjOmZvcm1hdD4KICAgICAgICA8ZGM6dHlwZQogICAgICAgICAgIHJkZjpyZXNvdXJjZT0iaHR0cDovL3B1cmwub3JnL2RjL2RjbWl0eXBlL1N0aWxsSW1hZ2UiIC8+CiAgICAgICAgPGRjOnRpdGxlPjwvZGM6dGl0bGU+CiAgICAgIDwvY2M6V29yaz4KICAgIDwvcmRmOlJERj4KICA8L21ldGFkYXRhPgogIDxnCiAgICAgaW5rc2NhcGU6bGFiZWw9IkxheWVyIDEiCiAgICAgaW5rc2NhcGU6Z3JvdXBtb2RlPSJsYXllciIKICAgICBpZD0ibGF5ZXIxIgogICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03OS45ODYwNjUsLTEzNS40NTkyNykiPgogICAgPGcKICAgICAgIHRyYW5zZm9ybT0ibWF0cml4KDAuMjY0NTgzMzMsMCwwLDAuMjY0NTgzMzMsMTMuMDMxMTc2LDQ5LjU5NjEwNikiCiAgICAgICBpZD0iZzYwODUiPgogICAgICA8cGF0aAogICAgICAgICBpbmtzY2FwZTpjb25uZWN0b3ItY3VydmF0dXJlPSIwIgogICAgICAgICBpZD0icGF0aDgiCiAgICAgICAgIHN0eWxlPSJmaWxsOiMyZWMxZWM7ZmlsbC1ydWxlOmV2ZW5vZGQiCiAgICAgICAgIGQ9Im0gMjg4Ljg0NjcsMzM1LjU0MzEgaCAtNS4zODQ0IHYgLTIuMTUzOCBjIDAsLTAuMjk3NiAtMC4yNDA5LC0wLjUzODUgLTAuNTM4MywtMC41Mzg1IC0wLjI5NzYsMCAtMC41Mzg2LDAuMjQwOSAtMC41Mzg2LDAuNTM4NSB2IDQuODQ1OSBjIDAsMC4yOTc2IDAuMjQxLDAuNTM4NiAwLjUzODYsMC41Mzg2IDAuMjk3NCwwIDAuNTM4MywtMC4yNDEgMC41MzgzLC0wLjUzODYgViAzMzYuNjIgaCA1LjM4NDQgYyAwLjg5MDcsMCAxLjYxNTIsMC43MjQ1IDEuNjE1MiwxLjYxNTIgdiA0Ljg0NTggaCAtMjcuOTk4NCB2IC00Ljg0NTggYyAwLC0wLjg5MDcgMC43MjQzLC0xLjYxNTIgMS42MTUyLC0xLjYxNTIgaCA0LjMwNzUgdiAtMS4wNzY5IGggLTQuMzA3NSBjIC0xLjQ4NDUsMCAtMi42OTIzLDEuMjA3OSAtMi42OTIzLDIuNjkyMSBsIDJlLTQsMjIuMDc1OSBjIDAsMS40ODQyIDEuMjA3NiwyLjY5MjEgMi42OTIxLDIuNjkyMSBoIDI0Ljc2OCBjIDEuNDg0MiwwIDIuNjkyMSwtMS4yMDc5IDIuNjkyMSwtMi42OTIxIHYgLTIyLjA3NTkgYyAwLC0xLjQ4NDIgLTEuMjA3OSwtMi42OTIxIC0yLjY5MjEsLTIuNjkyMSB6IG0gMCwyNi4zODMyIGggLTI0Ljc2OCBjIC0wLjg5MDYsMCAtMS42MTU1LC0wLjcyNDUgLTEuNjE1NSwtMS42MTUyIGwgM2UtNCwtMTYuMTUzMiBoIDI3Ljk5ODQgdiAxNi4xNTMyIGMgMCwwLjg5MDcgLTAuNzI0NSwxLjYxNTIgLTEuNjE1MiwxLjYxNTIgeiIgLz4KICAgICAgPHBhdGgKICAgICAgICAgaW5rc2NhcGU6Y29ubmVjdG9yLWN1cnZhdHVyZT0iMCIKICAgICAgICAgaWQ9InBhdGgxMCIKICAgICAgICAgc3R5bGU9ImZpbGw6IzJlYzFlYztmaWxsLXJ1bGU6ZXZlbm9kZCIKICAgICAgICAgZD0ibSAyNzAuMDAxNywzMzguNzczOCBjIDAuMjk3NCwwIDAuNTM4MywtMC4yNDEgMC41MzgzLC0wLjUzODYgViAzMzYuNjIgaCAxMC43Njg1IHYgLTEuMDc2OSBIIDI3MC41NCB2IC0yLjE1MzggYyAwLC0wLjI5NzYgLTAuMjQwOSwtMC41Mzg1IC0wLjUzODYsLTAuNTM4NSAtMC4yOTczLDAgLTAuNTM4MywwLjI0MDkgLTAuNTM4MywwLjUzODUgdiA0Ljg0NTkgYyAwLDAuMjk3NiAwLjI0MDcsMC41Mzg2IDAuNTM4NiwwLjUzODYgeiIgLz4KICAgICAgPHBhdGgKICAgICAgICAgaW5rc2NhcGU6Y29ubmVjdG9yLWN1cnZhdHVyZT0iMCIKICAgICAgICAgaWQ9InBhdGgxMiIKICAgICAgICAgc3R5bGU9ImZpbGw6IzJlYzFlYztmaWxsLXJ1bGU6ZXZlbm9kZCIKICAgICAgICAgZD0ibSAyNzMuMzc2OSwzNDguODQ0NCAtMi41NjA1LDEuMTU0MyAwLjE3MjYsMC40MjQzIDIuMjI4NiwtMC45OTQ5IHYgNy4yMDM5IGggLTIuMzYxNSB2IDAuNDY0MyBoIDUuMjE0IHYgLTAuNDY0MyBoIC0yLjM0ODIgdiAtNy43ODc2IHoiIC8+CiAgICAgIDxwYXRoCiAgICAgICAgIGlua3NjYXBlOmNvbm5lY3Rvci1jdXJ2YXR1cmU9IjAiCiAgICAgICAgIGlkPSJwYXRoMTA4IgogICAgICAgICBzdHlsZT0iZmlsbDojMmVjMWVjO2ZpbGwtcnVsZTpldmVub2RkIgogICAgICAgICBkPSJtIDI4MC41NzY5LDM0OC44NDQ0IC0yLjU2MDUsMS4xNTQzIDAuMTcyNiwwLjQyNDMgMi4yMjg2LC0wLjk5NDkgdiA3LjIwMzkgaCAtMi4zNjE1IHYgMC40NjQzIGggNS4yMTQgdiAtMC40NjQzIGggLTIuMzQ4MiB2IC03Ljc4NzYgeiIgLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding: 0 1rem;\n    display: flex;\n    align-items: center;\n    p {\n        font-size: 70%;\n        line-height: 120%;\n        font-weight: bold;\n        text-align: left;\n    }\n    @media (max-width: ', ') {\n        width: 80%;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    @media (max-width: ', ') {\n        width: 100%;\n        flex-direction: column;\n        p {\n            font-size: 100%;\n            line-height: initial;\n        }\n    }\n'], ['\n    padding: 0 1rem;\n    display: flex;\n    align-items: center;\n    p {\n        font-size: 70%;\n        line-height: 120%;\n        font-weight: bold;\n        text-align: left;\n    }\n    @media (max-width: ', ') {\n        width: 80%;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    @media (max-width: ', ') {\n        width: 100%;\n        flex-direction: column;\n        p {\n            font-size: 100%;\n            line-height: initial;\n        }\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    align-items: center;\n    margin-bottom: 1rem;\n    img {\n        height: 50px;\n        margin-right: 0.5rem;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    margin-bottom: 1rem;\n    img {\n        height: 50px;\n        margin-right: 0.5rem;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    position: relative;\n    width: 70%;\n    margin-left: 0.5rem;\n    &:before {\n        content: \'\';\n        border-left: 1px dotted #087ea8;\n        display: block;\n        width: 1px;\n        height: 100%;\n        left: 10px;\n        position: absolute;\n        z-index: -1;\n    }\n    @media (max-width: ', ') {\n        margin-left: 7.5rem;\n    }\n    @media (max-width: ', ') {\n        margin-left: 1.7rem;\n        margin-top: 1rem;\n        width: 100%;\n    }\n'], ['\n    position: relative;\n    width: 70%;\n    margin-left: 0.5rem;\n    &:before {\n        content: \'\';\n        border-left: 1px dotted #087ea8;\n        display: block;\n        width: 1px;\n        height: 100%;\n        left: 10px;\n        position: absolute;\n        z-index: -1;\n    }\n    @media (max-width: ', ') {\n        margin-left: 7.5rem;\n    }\n    @media (max-width: ', ') {\n        margin-left: 1.7rem;\n        margin-top: 1rem;\n        width: 100%;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    align-items: center;\n    margin-bottom: 1rem;\n    &:last-of-type {\n        margin-bottom: 0;\n    }\n    span {\n        display: inline-block;\n        margin-right: 1.4rem;\n        font-size: 60%;\n        text-align: center;\n        width: 20px;\n        height: 20px;\n        line-height: 2;\n        color: white;\n        border-radius: 80px;\n        border: 1px solid #087ea8;\n        background-color: #087ea8;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    margin-bottom: 1rem;\n    &:last-of-type {\n        margin-bottom: 0;\n    }\n    span {\n        display: inline-block;\n        margin-right: 1.4rem;\n        font-size: 60%;\n        text-align: center;\n        width: 20px;\n        height: 20px;\n        line-height: 2;\n        color: white;\n        border-radius: 80px;\n        border: 1px solid #087ea8;\n        background-color: #087ea8;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    p:nth-of-type(2) {\n        color: #22c3f1;\n    }\n'], ['\n    p:nth-of-type(2) {\n        color: #22c3f1;\n    }\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactIntl = __webpack_require__(7);
	
	var _constants = __webpack_require__(30);
	
	var _calend = __webpack_require__(514);
	
	var _calend2 = _interopRequireDefault(_calend);
	
	var _placeMarker = __webpack_require__(516);
	
	var _placeMarker2 = _interopRequireDefault(_placeMarker);
	
	var _covid = __webpack_require__(515);
	
	var _covid2 = _interopRequireDefault(_covid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject, _constants.breakpoints.tablet, _constants.breakpoints.mobile);
	
	var Item = _styledComponents2.default.div(_templateObject2);
	
	var ScheduleDatesItems = _styledComponents2.default.div(_templateObject3, _constants.breakpoints.tablet, _constants.breakpoints.mobile);
	
	var ScheduleDatesItem = _styledComponents2.default.div(_templateObject4);
	var ScheduleDate = _styledComponents2.default.div(_templateObject5);
	
	var Component = function Component(_ref) {
	    var style = _ref.style,
	        className = _ref.className,
	        intl = _ref.intl;
	    return _react2.default.createElement(
	        Wrapper,
	        { style: style, className: className },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                Item,
	                null,
	                _react2.default.createElement('img', { src: _calend2.default }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '8\u20229\u202210'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'scheduleWidget.dates' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                Item,
	                null,
	                _react2.default.createElement('img', { src: _placeMarker2.default }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: 'https://yandex.ru/maps/-/CBRxQKVeOD',
	                                target: '__blank'
	                            },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'scheduleWidget.address' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                Item,
	                null,
	                _react2.default.createElement('img', { src: _covid2.default }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '/files/COVID-19_' + (intl.locale === 'ru' ? 'rus' : 'eng') + '.pdf'
	                            },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'scheduleWidget.covid19' })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            ScheduleDatesItems,
	            null,
	            _react2.default.createElement(
	                ScheduleDatesItem,
	                null,
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    '8'
	                ),
	                _react2.default.createElement(
	                    ScheduleDate,
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'scheduleWidget.date1', tagName: 'p' }),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '10:00 - 18:00'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                ScheduleDatesItem,
	                null,
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    '9'
	                ),
	                _react2.default.createElement(
	                    ScheduleDate,
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'scheduleWidget.date2', tagName: 'p' }),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '10:00 - 18:00'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                ScheduleDatesItem,
	                null,
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    '10'
	                ),
	                _react2.default.createElement(
	                    ScheduleDate,
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'scheduleWidget.date3', tagName: 'p' }),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '10:00 - 16:00'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(Component);
	module.exports = exports['default'];

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    flex: 1;\n    width: 100%;\n    p {\n        margin-bottom: 20px;\n        text-align: justify;\n        &:last-of-type {\n            margin-bottom: 0;\n        }\n    }\n    iframe {\n        max-width: 100%;\n    }\n'], ['\n    flex: 1;\n    width: 100%;\n    p {\n        margin-bottom: 20px;\n        text-align: justify;\n        &:last-of-type {\n            margin-bottom: 0;\n        }\n    }\n    iframe {\n        max-width: 100%;\n    }\n']);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	exports.default = Content;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/page-header-backgound.a29a0cbb.jpg";

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    color: white;\n    margin-left: 200px;\n    @media (max-width: ', ') {\n        margin-left: 0;\n        order: 2;\n        min-width: 60%;\n    }\n    @media (max-width: ', ') {\n        h3 {\n            font-size: 1.5rem !important;\n        }\n    }\n'], ['\n    color: white;\n    margin-left: 200px;\n    @media (max-width: ', ') {\n        margin-left: 0;\n        order: 2;\n        min-width: 60%;\n    }\n    @media (max-width: ', ') {\n        h3 {\n            font-size: 1.5rem !important;\n        }\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-right: 200px;\n    font-size: 1.42rem;\n    font-weight: bold;\n    color: white;\n    @media (max-width: ', ') {\n        order: 1;\n        margin: 0 0 30px 0;\n    }\n    @media (max-width: ', ') {\n        font-size: 1.1rem;\n    }\n'], ['\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-right: 200px;\n    font-size: 1.42rem;\n    font-weight: bold;\n    color: white;\n    @media (max-width: ', ') {\n        order: 1;\n        margin: 0 0 30px 0;\n    }\n    @media (max-width: ', ') {\n        font-size: 1.1rem;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    flex: 1;\n    color: white;\n    font-size: 3.5rem;\n    line-height: 3.5rem;\n    font-weight: normal;\n    margin-right: 10px;\n    @media (max-width: ', ') {\n        font-size: 2.5rem;\n    }\n'], ['\n    flex: 1;\n    color: white;\n    font-size: 3.5rem;\n    line-height: 3.5rem;\n    font-weight: normal;\n    margin-right: 10px;\n    @media (max-width: ', ') {\n        font-size: 2.5rem;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    font-size: 80%;\n'], ['\n    font-size: 80%;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 146px;\n    background: url(', ') center center no-repeat no-repeat;\n    background-size: cover;\n    @media (max-width: ', ') {\n        flex-wrap: wrap;\n        height: auto;\n        padding: 40px 30px;\n    }\n    @media (max-width: ', ') {\n        justify-content: center;\n    }\n'], ['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 146px;\n    background: url(', ') center center no-repeat no-repeat;\n    background-size: cover;\n    @media (max-width: ', ') {\n        flex-wrap: wrap;\n        height: auto;\n        padding: 40px 30px;\n    }\n    @media (max-width: ', ') {\n        justify-content: center;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width: 350px;\n    margin-left: 100px;\n    @media (max-width: ', ') {\n        display: ', ';\n        margin-left: 20px;\n        width: 35%;\n        max-width: 250px;\n    }\n    @media (max-width: ', ') {\n        margin-left: 30px;\n        width: 100%;\n        text-align: center;\n    }\n'], ['\n    width: 350px;\n    margin-left: 100px;\n    @media (max-width: ', ') {\n        display: ', ';\n        margin-left: 20px;\n        width: 35%;\n        max-width: 250px;\n    }\n    @media (max-width: ', ') {\n        margin-left: 30px;\n        width: 100%;\n        text-align: center;\n    }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    padding: 60px 200px;\n    @media (max-width: ', ') {\n        // display: block;\n        padding: 30px;\n    }\n'], ['\n    display: flex;\n    padding: 60px 200px;\n    @media (max-width: ', ') {\n        // display: block;\n        padding: 30px;\n    }\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rehypeReact = __webpack_require__(213);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactIntl = __webpack_require__(7);
	
	var _ContactForm = __webpack_require__(246);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _ConferenctProgramForm = __webpack_require__(618);
	
	var _ConferenctProgramForm2 = _interopRequireDefault(_ConferenctProgramForm);
	
	var _ExhibitorsList = __webpack_require__(620);
	
	var _ExhibitorsList2 = _interopRequireDefault(_ExhibitorsList);
	
	var _Content = __webpack_require__(126);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _constants = __webpack_require__(30);
	
	var _ScheduleWidget = __webpack_require__(247);
	
	var _ScheduleWidget2 = _interopRequireDefault(_ScheduleWidget);
	
	var _pageHeaderBackgound = __webpack_require__(217);
	
	var _pageHeaderBackgound2 = _interopRequireDefault(_pageHeaderBackgound);
	
	var _ruvents = __webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Title = _styledComponents2.default.div(_templateObject, _constants.breakpoints.tablet, _constants.breakpoints.mobile);
	
	var Dates = _styledComponents2.default.div(_templateObject2, _constants.breakpoints.tablet, _constants.breakpoints.mobile);
	
	var Numbers = _styledComponents2.default.div(_templateObject3, _constants.breakpoints.mobile);
	
	var Place = _styledComponents2.default.div(_templateObject4);
	
	var Header = _styledComponents2.default.div(_templateObject5, _pageHeaderBackgound2.default, _constants.breakpoints.tablet, _constants.breakpoints.mobile);
	
	var Banners = _styledComponents2.default.div(_templateObject6, _constants.breakpoints.tablet, function (_ref) {
	    var hasBanners = _ref.hasBanners;
	    return hasBanners ? 'block' : 'none';
	}, _constants.breakpoints.mobile);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject7, _constants.breakpoints.tablet);
	
	var renderAst = new _rehypeReact2.default({
	    createElement: _react2.default.createElement,
	    components: {
	        'contact-form': _ContactForm2.default,
	        'conference-program-form': _ConferenctProgramForm2.default
	    }
	}).Compiler;
	
	var Template = function (_React$PureComponent) {
	    _inherits(Template, _React$PureComponent);
	
	    function Template() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Template);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
	            exhibitorsFilter: null,
	            exhibitorsFilterOpened: false
	        }, _this.setExhibitorsFilter = function (filter) {
	            _this.setState({ exhibitorsFilter: filter });
	        }, _this.toggleExhibitorsFilter = function () {
	            _this.setState({
	                exhibitorsFilterOpened: !_this.state.exhibitorsFilterOpened
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Template.prototype.componentDidMount = function componentDidMount() {
	        if (this.props.data.article.slug === 'registration' && window.easyXDM) {
	            var widgets = document.querySelectorAll('.ruv-widget');
	            for (var i = 0; i < widgets.length; i++) {
	                var widget = widgets[i];
	                new _ruvents.RUVWidget(widget);
	            }
	        }
	    };
	
	    Template.prototype.render = function render() {
	        var _props$data = this.props.data,
	            article = _props$data.article,
	            exhibitors = _props$data.exhibitors,
	            exhibitorsImages = _props$data.exhibitorsImages,
	            banners = _props$data.banners;
	
	        var htmlAst = article.content && article.content.childMarkdownRemark.htmlAst;
	        var isExhibitorsListPage = this.props.location && /\/pages\/exhibitors-list/.test(this.props.location.pathname);
	
	        return _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                Header,
	                null,
	                _react2.default.createElement(
	                    Title,
	                    null,
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'title is-3', style: { color: 'white' } },
	                        article.title
	                    )
	                ),
	                _react2.default.createElement(
	                    Dates,
	                    null,
	                    _react2.default.createElement(
	                        Numbers,
	                        null,
	                        '8\u20229\u202210'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { fontSize: '80%' } },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.dates.date' })
	                        ),
	                        _react2.default.createElement(
	                            Place,
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.dates.place' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                ContentWrapper,
	                null,
	                _react2.default.createElement(
	                    _Content2.default,
	                    { className: 'content' },
	                    htmlAst && renderAst(htmlAst),
	                    isExhibitorsListPage && _react2.default.createElement(_ExhibitorsList2.default, {
	                        exhibitors: exhibitors.edges,
	                        logos: exhibitorsImages.edges,
	                        filter: this.state.exhibitorsFilter,
	                        filterOpened: this.state.exhibitorsFilterOpened,
	                        toggleFilter: this.toggleExhibitorsFilter,
	                        setExhibitorsFilter: this.setExhibitorsFilter
	                    })
	                ),
	                _react2.default.createElement(
	                    Banners,
	                    { hasBanners: !!banners },
	                    ['Посетителям', 'Участникам', 'Дополнительные возможности', 'Attendee', 'Exhibitors', 'Additional opportunities'].indexOf(article.title) !== -1 && _react2.default.createElement(_ScheduleWidget2.default, null),
	                    banners && banners.edges.map(function (_ref2, idx) {
	                        var node = _ref2.node;
	                        return _react2.default.createElement(
	                            'div',
	                            { key: idx, style: { marginBottom: 40 } },
	                            _react2.default.createElement(
	                                'a',
	                                { href: node.link, target: '_blank' },
	                                _react2.default.createElement('img', {
	                                    style: { width: '100%' },
	                                    src: node.banner.file.url
	                                })
	                            )
	                        );
	                    })
	                )
	            )
	        );
	    };
	
	    return Template;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _reactIntl.injectIntl)(Template);
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var domain = 'https://ruvents.com/';
	
	var RUVWidget = exports.RUVWidget = new function () {
	    function RUVWidget(container) {
	        this.registerStyle();
	
	        this.baseUrl = domain + 'widget/main/index';
	        this.url = document.location;
	        this.container = container;
	        this.event = container.getAttribute('data-event');
	        this.lang = container.getAttribute('data-lang');
	
	        this.preloader = document.createElement('div');
	        this.preloader.setAttribute('style', "display:block;position:absolute;left:50%;margin-left:-50px;height:50px;width:50px;background: url('//runet-id.com/images/api/widget-preloder.gif') no-repeat center center;");
	        this.container.appendChild(this.preloader);
	
	        this.initSocket();
	    }
	
	    RUVWidget.prototype.registerStyle = function () {
	        var style = document.createElement('style');
	        style.innerText = '.ruv-widget > iframe {visibility:hidden;} .ruv-widget iframe {overflow:hidden;}';
	        document.getElementsByTagName('body')[0].insertBefore(style, null);
	    };
	
	    RUVWidget.prototype.initSocket = function () {
	        var self = this;
	        var socket = new easyXDM.Socket({
	            remote: self.getUrl(),
	            container: self.container,
	            onMessage: function onMessage(message, origin) {
	                self.preloader.style.display = 'none';
	                var iframe = this.container.getElementsByTagName('iframe')[0];
	                iframe.scrolling = 'no';
	                iframe.style.visibility = 'visible';
	                iframe.style.width = '100%';
	                iframe.style.height = 4 + parseInt(message) + 'px';
	            }
	        });
	    };
	
	    RUVWidget.prototype.getUrl = function () {
	        var self = this;
	        var action = self.action != null ? self.action : 'index';
	
	        var url = '/widget/event-register/' + action + '?' + 'event=' + self.event;
	        if (self.lang) {
	            url += '&lang=' + self.lang + '&langnocookie=1';
	        }
	
	        for (var i = 0; i < this.container.attributes.length; i++) {
	            var attr = this.container.attributes.item(i);
	            if (attr.nodeName.indexOf('data-param-') != -1) {
	                url += '&' + attr.nodeName.substr(5) + '=' + encodeURIComponent(attr.nodeValue);
	            }
	        }
	
	        url = self.baseUrl + '?url=' + encodeURIComponent(url);
	        return url;
	    };
	    return RUVWidget;
	}();

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-template-js-3f33e343a6d047a427a6.js